<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [xaxis]="chartOptions.xaxis!"
        [stroke]="chartOptions.stroke!"
        [tooltip]="chartOptions.tooltip!"
        [dataLabels]="chartOptions.dataLabels!"
        [fill]="chartOptions.fill!"
        [markers]="chartOptions.markers!"
        [theme]="chartOptions.theme!"
        [yaxis]="chartOptions.yaxis!"
        [title]="chartOptions.title!"
        [colors]="chartOptions.colors!"
        [grid]="chartOptions.grid!"
    ></apx-chart>
</div>